import { useLocation, useNavigate } from "react-router-dom";

// Todas las rutas que renderizan la HomePage (ver App.js)
const HOMEPAGE_ROUTES = ["/", "/contacto", "/servicios", "/sobre-mi"];

/**
 * Hook que devuelve un handler para los CTAs de "ir a contacto".
 *
 * - Si el usuario YA está en la HomePage (cualquiera de las rutas que la renderizan),
 *   hace scrollIntoView manual a #contacto SIN pasar por React Router.
 *   Esto evita el bug de "click a la misma URL = sin re-render = no scroll".
 *
 * - Si está en otra página (landings, blog, calculadora...), navega normalmente a /contacto.
 *
 * Mantiene el href de los <Link> para SEO/accesibilidad: solo previene el default
 * cuando hace falta scrollear manualmente.
 */
export const useScrollToSection = (sectionId = "contacto") => {
  const location = useLocation();
  const navigate = useNavigate();

  return (e) => {
    if (HOMEPAGE_ROUTES.includes(location.pathname)) {
      e?.preventDefault?.();
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      // Sincronizamos la URL silenciosamente para consistencia, sin re-render de Router
      const targetPath = sectionId === "contacto" ? "/contacto" : `/${sectionId}`;
      if (location.pathname !== targetPath) {
        window.history.replaceState(null, "", targetPath);
      }
    }
    // En otras páginas (landings/blog) dejamos que el <Link to="/contacto"> haga su trabajo normal
  };
};
